import React from 'react';

import InputEncryptionButton from '../commons/InputEncryptionButton';
import {RenderProps} from '../components/atoms/BaseInput/types';

export const getInputMask = (maskLength: number) =>
  Array(maskLength).fill(/\d/);

type EncryptValueType = (
  value: string | number,
  customSymbol?: string,
) => string;

export const encryptValue: EncryptValueType = (value, customSymbol) => {
  const cleanValue = String(value).replace(/\s*[-_/]+\s*/g, '');

  const encryptedValue = Array(cleanValue.length)
    .fill(0)
    .map(() => customSymbol || '*')
    .join('');

  return encryptedValue;
};

interface HandleEncryptedRenderProps {
  renderProps?: RenderProps;
  encryptedValue: boolean;
  disableStyles?: boolean;
  encrypt: boolean;
  handleEncryption: () => void;
}

export const encryptedRenderPropsGenerator = ({
  renderProps,
  encryptedValue,
  encrypt,
  disableStyles = true,
  handleEncryption,
}: HandleEncryptedRenderProps): RenderProps => {
  let customRenderProps: RenderProps = {
    ...renderProps,
  };

  if (encryptedValue) {
    customRenderProps = {
      ...customRenderProps,
      disabled: disableStyles && encrypt,
      customSlot: () => (
        <InputEncryptionButton
          encrypt={encrypt}
          handleEncrypt={handleEncryption}
        />
      ),
    };
  }

  return customRenderProps;
};

export const focusOnNextInput = (currentInput: HTMLInputElement) => {
  const inputs = document.getElementsByTagName('input');
  const currentIndex = Array.from(inputs).findIndex((input) => {
    return input === currentInput;
  });
  const nextIndex = (currentIndex + 1) % inputs.length;
  // List of all inputs that go after the current one
  const nextInputsList = Array.from(inputs).slice(nextIndex);
  // Find the next input that's not disabled or is a checkbox
  const nextInput = nextInputsList.find(
    (input) => !input.disabled && input.type !== 'checkbox',
  );

  nextInput.focus();
};
